'use strict';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import {Observable} from 'rxjs/Observable';
import {navStates} from '../../app/router';
import {PROFILE, TOKEN} from '../../config/constants/auth-keys';
import {AbstractEpics} from '../../core-utilities/redux/AbstractEpics';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {authFirebase, lockSuccess, stateGoPostAuth, tokenRefreshed} from '../actions';
import {loginUserRequest} from '../redux/loginUser';
import {refreshUserRequest} from '../redux/refreshUser';
import {signupUserRequest} from '../redux/signupUser';
import {expiresIn, MIN, removeRefreshToken, saveRefreshToken} from '../utils/token';
import {logger} from './logger';
import {onExpired} from './onLocationChange';


export class LoginEpics extends AbstractEpics {

  constructor(options) {
    super(options);

    this.onLoginUser = this.onLoginUser.bind(this);
    this.onLockSuccess = this.onLockSuccess.bind(this);
    this.onRefreshUser = this.onRefreshUser.bind(this);
    this.onSignupUser = this.onSignupUser.bind(this);

    this.storeBoth = this.storeBoth.bind(this);
    this.storeToken = this.storeToken.bind(this);

    this.onLoginUser.$inject = [
      'audioNotificationService',
    ];

    this.onLockSuccess.$inject = [
      'authCacheService',
    ];

    this.addEpics([
      this.onLoginUser,
      this.onLockSuccess,
      this.onRefreshUser,
      this.onSignupUser,
    ]);
  }

  onLoginUser(action$, store, dependencies) {
    return action$.ofType(loginUserRequest.actions.requestSuccess.TYPE)
      .mergeMap(action => {
        // dependencies.audioNotificationService.playLogin();

        const authData = action.payload.ajaxResponse.response;
        return Observable.from([
          lockSuccess({profile: authData.profile, token: authData.idToken, refreshToken: authData.refreshToken}),
          authFirebase(authData.firebaseToken),
        ]);
      })
      .catch(epicErrorHandler(this.logger, 'onLoginUser'));
  }

  onRefreshUser(action$) {
    return action$.ofType(refreshUserRequest.actions.requestSuccess.TYPE)
      .mergeMap(action => {
        const authData = action.payload.ajaxResponse.response;
        if (authData.idToken) {
          return Observable.from([
            tokenRefreshed({token: authData.idToken}),
            authFirebase(authData.firebaseToken),
          ]);
        } else {
          return Observable
            .merge(
              removeRefreshToken(),
              Observable.of(refreshUserRequest.actions.requestError({err: new Error('Refresh token is not valid')})),
            );
        }
      })
      .filter(action => !!action)
      .catch(epicErrorHandler(this.logger, 'onRefreshUser'));
  }

  // TODO: improve new user signup flow by showing tutorials or something
  // TODO: prompt user to verify email address before sending them anywhere else unless they are signing up from an org invite with a matching email address
  onSignupUser(action$) {
    return action$.ofType(signupUserRequest.actions.requestSuccess.TYPE)
      .mergeMap(action => {
        const authData = action.payload.ajaxResponse.response;
        return Observable.from([
          // For now, go to orgs list. in future send to tutorial or something.
          stateGoPostAuth(navStates.orgsList),
          lockSuccess({profile: authData.profile, token: authData.idToken, refreshToken: authData.refreshToken}),
          authFirebase(authData.firebaseToken),
        ]);
      })
      .catch(epicErrorHandler(this.logger, 'onSignupUser'));
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @param {Object} dependencies
   * @param {AuthCacheService} dependencies.authCacheService
   * @returns {Observable<any>}
   */
  onLockSuccess(action$, store, dependencies) {
    // HACK: kind of a hack. Should probably inject this class as a service directly.
    this.dependencies = dependencies;

    return Observable
      .merge(
        action$.ofType(lockSuccess.TYPE).mergeMap(this.storeBoth),
        action$.ofType(tokenRefreshed.TYPE).mergeMap(this.storeToken)
      )
      .switchMap(action => {
        const token = action.payload.token;
        const delay = expiresIn(token) - MIN;
        return Observable.timer(delay)
          .take(1)
          .mergeMap(onExpired);
      })
      .catch(epicErrorHandler(logger, 'onLockSuccess'));
  }

  storeBoth(action) {
    return Observable
      .combineLatest(
        this.dependencies.authCacheService.setItem(PROFILE, action.payload.profile),
        this.dependencies.authCacheService.setItem(TOKEN, action.payload.token),
        saveRefreshToken(action.payload.refreshToken),
      )
      .mapTo(action)
      .catch(() => Observable.of(action));
  }

  storeToken(action) {
    return Observable
      .fromPromise(this.dependencies.authCacheService.setItem(TOKEN, action.payload.token))
      .mapTo(action)
      .catch(() => Observable.of(action));
  }
}

export const epics = new LoginEpics({logger}).epics;



// WEBPACK FOOTER //
// ./src/js/auth/epics/onLogin.js